import { useWelcomeEnabled, setWelcomeEnabled } from '../lib/welcome';

// On/Off picker for the sign-in welcome greeting. Inline-styled so it drops
// into both the Engineer/CEO Tools tab and the detailer settings modal.
// The caller supplies `heading` to match its context.
export default function WelcomeToggle({ role, heading }) {
  const on = useWelcomeEnabled(role);

  const pill = (active) => ({
    flex: 1,
    padding: '10px 12px',
    border: '1px solid ' + (active ? 'var(--blue)' : 'var(--border)'),
    background: active ? 'var(--blue-dim, rgba(37,99,235,0.12))' : 'transparent',
    color: 'var(--text)',
    borderRadius: 'var(--radius, 10px)',
    cursor: 'pointer',
    fontSize: 13,
    fontWeight: 700,
    fontFamily: 'inherit',
  });

  return (
    <>
      {heading}
      <div style={{ fontSize: 12, color: 'var(--muted)', marginBottom: 8, lineHeight: 1.4 }}>
        A short greeting when you sign in — tailored to your role.
      </div>
      <div style={{ display: 'flex', gap: 8 }}>
        <button onClick={() => setWelcomeEnabled(role, true)} style={pill(on)}>
          On{on && <span style={{ color: 'var(--blue)', fontSize: 10, marginLeft: 6 }}>● ON</span>}
        </button>
        <button onClick={() => setWelcomeEnabled(role, false)} style={pill(!on)}>
          Off{!on && <span style={{ color: 'var(--blue)', fontSize: 10, marginLeft: 6 }}>● ON</span>}
        </button>
      </div>
    </>
  );
}
